import type { JSX } from 'react';

/**
 * Inline globe glyph for the group-consult timezone selector.
 *
 * @remarks Decorative, so `aria-hidden`: the adjacent visible "Timezone" label already names the
 * control, and an unlabelled `<svg>` is exposed as a graphics role by some AT.
 */
export function GlobeIcon({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      className={className}
      aria-hidden="true"
      focusable="false"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  );
}
